export const cleanDateFormat = date => {
  if (date) {
    const newDate = date.split("-");
    newDate[newDate.length - 1] = newDate[newDate.length - 1].replace(/\./g, ":");

    const hms = newDate[3].split(":");
    hms.pop();

    return `${newDate[0]}-${newDate[1]}-${newDate[2]} ${hms.join(":")}`;
  }
  return null;
};
